import appFooter from './appFooter.vue'

export default appFooter
